<template>
  <div class="main-content">
    <div class="content-inner">
      <video
        class="videobox"
        :poster="videoData.CoverImageUrl"
        :src="videoData.Url"
        controls="controls"
        controlsList="nodownload"
      ></video>
      <div class="title-name">
        {{ videoData.CoursewareName ? videoData.CoursewareName : "暂无详情" }}
      </div>
      <div class="content">
        {{ videoData.Description }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "play-detail",
  data() {
    return {
      videoData: {},
    };
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize(){
      this.videoData = this.$route.query
    }
  },
};
</script>
<style lang="less" scoped>
.main-content {
  max-width: 1420px;
  margin: 40px auto;
  .content-inner {
    margin: 0 20px;
    min-height: 400px;
  }
}
.videobox {
  height: 675px;
  background: rgba(0, 0, 0, 0);
  border-radius: 20px;
  width: 100%;
  object-fit: fill;
}
.title-name {
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  color: #31415e;
  margin: 24px 0;
}
.content {
  font-size: 16px;
  line-height: 32px;
  color: #31415e;
}
</style>
